import styled from "styled-components";

export const FlagWrapper = styled.div``;

export const FlagImage = styled.img`
  margin: 0 auto;
  width: 40px;
  height: 40px;
  border: 2px solid rgb(0, 0, 0);
  border-radius: 50%;
  right: 0;
`;
